import { useState } from "react";
import { Box, Image } from "@chakra-ui/react";

interface ReplayableGifProps {
  gifSrc: string;
  styles?: React.CSSProperties;
}

const ReplayableGif = ({ gifSrc, styles }: ReplayableGifProps) => {
  const [isPlaying, setIsPlaying] = useState(true);

  const handleImageClick = () => {
    // Force reload the gif by toggling src
    setIsPlaying(false);
    setTimeout(() => setIsPlaying(true), 0);
  };

  return (
    <Box onClick={handleImageClick} cursor="pointer">
      {isPlaying && (
        <Image
          src={gifSrc}
          alt="Feature demonstration"
          width="100%"
          height="auto"
          style={styles}
        />
      )}
    </Box>
  );
};

export default ReplayableGif;
